// Utils
import moment from "moment";
import { formatDatetime } from "react-lib/utils/dateUtils";
import { HeaderLogoWithPublishDetail } from "react-lib/apps/HISV3/common/HeaderPdfFormTemplate";
import { TDocumentDefinitions } from "pdfmake/interfaces";

const FORM_NAME = `FormAnesAsaStatReport`;

const FormAnesAsaStatReport = async (props: any): Promise<TDocumentDefinitions> => {
  // console.log("Yeti Anes ASA Props: ", props);

  const currentDate = moment();

  const headerForm = await HeaderLogoWithPublishDetail({
    form: FORM_NAME,
    font: "THSarabunNew",
    logoHeight: 30,
    isHospitalVertical: true,
    haveBorder: true,
    pageMargins: [10, 85, 10, 10],
    headerMargins: [10, 10, 10, 0],
    titleContent: [
      {
        text: `จำนวนผู้รับบริการระงับความรู้สึก แบ่งตาม ASA`,
        alignment: "center",
        fontSize: 15,
        bold: true,
      },
      {
        text: `วิธีระงับความรู้สึก ${props.params?.anesthesia_label || "ทั้งหมด"}`,
        alignment: "center",
        fontSize: 15,
      },
      {
        text: `วันที่ดมยา ${props.params?.startDate || " "} - ${props.params?.endDate || " "}`,
        alignment: "center",
        fontSize: 15,
      },
    ],
    publishContent: [
      {
        text: [
          { text: "ผู้พิมพ์: ", bold: true, preserveLeadingSpaces: true },
          { text: props.params?.print_user || " " },
        ],
        alignment: "right",
        fontSize: 12,
      },
      {
        text: [
          { text: "วันที่พิมพ์: ", bold: true, preserveLeadingSpaces: true },
          { text: formatDatetime(currentDate, true) },
        ],
        alignment: "right",
        fontSize: 12,
      },
    ],
  });

  const { font, images, styles } = headerForm;

  const renameAsap = (name: string) => {
    const renameList: any = {
      "1": "Class I",
      "2": "Class II",
      "3": "Class III",
      "4": "Class IV",
      "5": "Class V",
      "6": "Class VI",
    };

    return renameList[name] || name;
  };

  const generateTableBody = (data: any, columns: string[]) => {
    let body: any = [];

    // Header of Table
    body.push([
      { text: "ASA Physical Status", bold: true, alignment: "center" },
      { text: "No Emergency", bold: true, alignment: "center" },
      { text: "Emergency", bold: true, alignment: "center" },
      { text: "รวมเคส/Class", bold: true, alignment: "center" },
    ]);

    if (Object.keys(data).length > 0) {
      const fieldsData = data?.emergencyReport;
      const summaryData = data?.emergencyTotals;

      fieldsData.forEach((row: any) => {
        let dataRow: any = [];

        columns.forEach((column: any) => {
          switch (column) {
            case "noEmergency":
            case "emergency":
            case "total":
              dataRow.push({ text: row[column], alignment: "center" });
              break;
            case "ASAPS":
              const asapName = renameAsap(row[column]);
              dataRow.push({ text: asapName, bold: true });
              break;
            default:
              dataRow.push({ text: row[column].toString() });
              break;
          }
        });
        body.push(dataRow);
      });

      // Total Row
      if (summaryData) {
        body.push([
          {
            text: "จำนวนผู้รับบริการรวม",
            fillColor: "#cccccc",
            border: [true, true, false, true],
          },
          {
            text: `No Emergency ${summaryData.noEmergency}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
            border: [false, true, false, true],
          },
          {
            text: `Emergncy ${summaryData.emergency}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
            border: [false, true, false, true],
          },
          {
            text: `เท่ากับ ${summaryData.total}`,
            fillColor: "#cccccc",
            bold: true,
            alignment: "center",
            border: [false, true, true, true],
          },
        ]);
      }
    }

    return body;
  };

  const tableReport = (data: any, columns: string[]) => {
    return {
      table: {
        widths: ["*", "15%", "15%", "15%"],
        headerRows: 1,
        body: generateTableBody(data, columns),
      },
    };
  };

  return {
    pageSize: "A4",
    pageOrientation: "landscape",
    defaultStyle: {
      font: font,
      lineHeight: 1,
      fontSize: 16, // default
    },
    ...headerForm,
    styles: { ...styles },
    images: { ...images },
    content: [
      tableReport(props || {}, [
        "ASAPS", //* ชื่อ ASAP ยังไม่ตรงกับ Table
        "noEmergency",
        "emergency",
        "total",
      ]),
    ],
  };
};

export default FormAnesAsaStatReport;
